<template>
  <option :value="repgroup.id">{{repgroup.business_name}}</option>
</template>

<script>
export default {
  name: "RepOptions",
  props: {
    repgroup: Object
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/factories/RepOptions.vue